var _ruleSets;

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  vertical-align: middle;\n  font-family: inherit;\n  font-size: inherit;\n  font-weight: inherit;\n  height: 1rem;\n  line-height: 1.125rem;\n  position: relative;\n"]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n  width: ", ";\n  height: ", ";\n  background-position: center;\n  background-repeat: no-repeat;\n  background-image: ", ";\n"]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  vertical-align: middle;\n  position: relative;\n\n  > svg {\n    display: block;\n  }\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  border-radius: 1rem;\n  border: none;\n  transition: color 0.3s, background-color 0.3s;\n  cursor: ", ";\n  outline: none;\n  min-height: 2rem;\n  min-width: ", ";\n  padding: ", ";\n  font-family: ", ";\n  font-size: 1rem;\n\n  > * {\n    &:not(:last-child) {\n      margin-right: 0.5rem;\n    }\n  }\n\n  ", "\n  ", "\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n      color: ", ";\n    "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n      color: ", ";\n    "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n      font-weight: ", ";\n      text-transform: lowercase;\n      background-color: transparent;\n\n      > * {\n        &:not(:last-child) {\n          margin-right: 0.5rem;\n        }\n      }\n    "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n      color: ", ";\n      background-color: transparent;\n\n      &:hover:not(:focus) {\n        background-color: rgba(0, 0, 0, 0.1);\n      }\n\n      &:focus {\n        background-color: rgba(0, 0, 0, 0.2);\n      }\n    "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n      color: ", ";\n      background-color: ", ";\n    "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n      font-weight: ", ";\n      text-transform: lowercase;\n    "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n      color: ", ";\n      background-color: transparent;\n\n      &:hover:not(:focus) {\n        background-color: rgba(0, 0, 0, 0.1);\n      }\n\n      &:focus {\n        background-color: rgba(0, 0, 0, 0.2);\n      }\n    "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n      color: ", ";\n    "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n      font-weight: ", ";\n      text-transform: uppercase;\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      color: #ffffff;\n      background-color: ", ";\n\n      &:hover:not(:focus) {\n        background-color: ", ";\n      }\n\n      &:focus {\n        background-color: ", ";\n      }\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      color: ", ";\n      background-color: ", ";\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n      font-weight: ", ";\n      text-transform: uppercase;\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import { css } from 'styled-components';
import styled from "../../theme";
import { ButtonTypes } from "./Button.types";
export var ruleSets = (_ruleSets = {}, _defineProperty(_ruleSets, ButtonTypes.PRIMARY, {
  common: css(_templateObject(), function (p) {
    return p.theme.variables.fonts.weight.medium;
  }),
  disabled: css(_templateObject2(), function (p) {
    return p.theme.variables.colors.midGrey;
  }, function (p) {
    return p.theme.variables.colors.silver;
  }),
  enabled: css(_templateObject3(), function (p) {
    return p.theme.variables.colors.red;
  }, function (p) {
    return p.theme.variables.colors.midRed;
  }, function (p) {
    return p.theme.variables.colors.darkRed;
  })
}), _defineProperty(_ruleSets, ButtonTypes.FLAT, {
  common: css(_templateObject4(), function (p) {
    return p.theme.variables.fonts.weight.medium;
  }),
  disabled: css(_templateObject5(), function (p) {
    return p.theme.variables.colors.darkGrey;
  }),
  enabled: css(_templateObject6(), function (p) {
    return p.theme.variables.colors.red;
  })
}), _defineProperty(_ruleSets, ButtonTypes.ICON, {
  common: css(_templateObject7(), function (p) {
    return p.theme.variables.fonts.weight.light;
  }),
  disabled: css(_templateObject8(), function (p) {
    return p.theme.variables.colors.midGrey;
  }, function (p) {
    return p.theme.variables.colors.silver;
  }),
  enabled: css(_templateObject9(), function (p) {
    return p.theme.variables.colors.black;
  })
}), _defineProperty(_ruleSets, ButtonTypes.NAVIGATION, {
  common: css(_templateObject10(), function (p) {
    return p.theme.variables.fonts.weight.light;
  }),
  disabled: css(_templateObject11(), function (p) {
    return p.theme.variables.colors.midGrey;
  }),
  enabled: css(_templateObject12(), function (p) {
    return p.theme.variables.colors.black;
  })
}), _ruleSets);

var getRuleSet = function getRuleSet(theme) {
  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ButtonTypes.PRIMARY;
  return ruleSets[name] || theme.ruleSets.button[name] || ruleSets[ButtonTypes.PRIMARY];
};

export var ButtonWrapper = styled.button(_templateObject13(), function (props) {
  return props.disabled ? 'not-allowed' : 'pointer';
}, function (props) {
  return props.iconOnly ? '2rem' : '5.5rem';
}, function (props) {
  return props.iconOnly ? '0' : "0 ".concat(props.theme.variables.button.horizontalPadding);
}, function (p) {
  return p.theme.variables.typography.secondaryFont;
}, function (props) {
  return getRuleSet(props.theme, props.ruleSet).common;
}, function (props) {
  return getRuleSet(props.theme, props.ruleSet)[props.disabled ? 'disabled' : 'enabled'];
});
export var IconWrapper = styled.div(_templateObject14());
export var BackgroundIcon = styled.div(_templateObject15(), function (p) {
  return p.theme.variables.icons.size[p.size] || p.size;
}, function (p) {
  return p.theme.variables.icons.size[p.size] || p.size;
}, function (p) {
  return "url(\"".concat(p.theme.variables.icons.svg[p.icon], "\")");
});
export var TextWrapper = styled.div(_templateObject16());